import Logo from "components/logo";
import Typography from "components/typography";
import LinkText from "components/typography/linkText";
import React from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";
import { ReactComponent as Waves } from "images/svg/processWaves.svg";
import { ReactComponent as Stars } from "images/svg/processStars.svg";
import BGImg from "images/png/processBgImg.png";

const Footer = () => {
  return (
    <Container>
      <BodyBgImg src={BGImg} alt="bg-img" />
      <StarsContainer>
        <Stars />
      </StarsContainer>
      <Body>
        <LogoArea>
          <Logo width="12rem" />
          <Typography my="3.2" size="xl" color={Colors.grey300}>
            Discover your ultimate gateway to music distribution, share your
            unique sounds.
          </Typography>
          <SocialMediaIcons>
            <SocialMediaIcon>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                viewBox="0 0 36 37"
                fill="none"
              >
                <rect
                  y="0.338867"
                  width="36"
                  height="36"
                  rx="8"
                  fill="#1E1E1E"
                />
                <path
                  d="M19.4648 27.3389V19.1282H22.3594L22.7928 15.9284H19.4647V13.8854C19.4647 12.959 19.7349 12.3277 21.1303 12.3277L22.91 12.3269V9.46494C22.6022 9.42601 21.5457 9.33887 20.3167 9.33887C17.7507 9.33887 15.9939 10.83 15.9939 13.5686V15.9284H13.0918V19.1282H15.9939V27.3388H19.4648V27.3389Z"
                  fill="#909090"
                />
              </svg>
            </SocialMediaIcon>
            <SocialMediaIcon>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                viewBox="0 0 36 37"
                fill="none"
              >
                <rect
                  y="0.338867"
                  width="36"
                  height="36"
                  rx="8"
                  fill="#1E1E1E"
                />
                <path
                  d="M21.0271 11.0404V11.0371H21.8711L22.1794 11.0987C22.385 11.1387 22.5717 11.1911 22.7394 11.2559C22.9071 11.3208 23.0694 11.3964 23.2263 11.4828C23.3832 11.5693 23.5255 11.6574 23.6532 11.747C23.7798 11.8356 23.8934 11.9297 23.9941 12.0291C24.0936 12.1296 24.2489 12.1555 24.4599 12.1069C24.6709 12.0582 24.8981 11.9907 25.1416 11.9043C25.385 11.8178 25.6258 11.7206 25.8638 11.6125C26.1019 11.5044 26.2469 11.4358 26.2988 11.4067C26.3497 11.3764 26.3768 11.3602 26.38 11.358L26.3832 11.3532L26.3995 11.3451L26.4157 11.337L26.4319 11.3289L26.4482 11.3208L26.4514 11.3159L26.4563 11.3127L26.4612 11.3094L26.4644 11.3045L26.4806 11.2997L26.4968 11.2964L26.4936 11.3208L26.4887 11.3451L26.4806 11.3694L26.4725 11.3937L26.4644 11.4099L26.4563 11.4261L26.4482 11.4504C26.4427 11.4666 26.4373 11.4882 26.4319 11.5153C26.4265 11.5423 26.3751 11.6503 26.2777 11.8394C26.1803 12.0285 26.0586 12.2203 25.9125 12.4148C25.7665 12.6093 25.6355 12.7563 25.5198 12.8557C25.4029 12.9562 25.3255 13.0264 25.2876 13.0664C25.2498 13.1075 25.2038 13.1453 25.1497 13.1799L25.0685 13.2333L25.0523 13.2415L25.0361 13.2496L25.0328 13.2544L25.028 13.2577L25.0231 13.2609L25.0198 13.2658L25.0036 13.2739L24.9874 13.282L24.9841 13.2868L24.9793 13.2901L24.9744 13.2933L24.9711 13.2982L24.9679 13.303L24.963 13.3063L24.9582 13.3095L24.9549 13.3144H25.0361L25.4905 13.2171C25.7935 13.1523 26.083 13.074 26.3589 12.9821L26.7971 12.8362L26.8458 12.82L26.8702 12.8119L26.8864 12.8038L26.9026 12.7957L26.9188 12.7876L26.9351 12.7795L26.9675 12.7747L27 12.7714V12.8038L26.9919 12.8071L26.9838 12.8119L26.9805 12.8168L26.9757 12.82L26.9708 12.8233L26.9675 12.8281L26.9643 12.833L26.9594 12.8362L26.9546 12.8395L26.9513 12.8443L26.9481 12.8492L26.9432 12.8525L26.9351 12.8687L26.927 12.8849L26.9221 12.8881C26.9199 12.8914 26.8512 12.9832 26.716 13.1637C26.5807 13.3452 26.5077 13.437 26.4968 13.4392C26.486 13.4424 26.4709 13.4586 26.4514 13.4878C26.433 13.5181 26.3183 13.6386 26.1073 13.8493C25.8963 14.06 25.6897 14.2474 25.4873 14.4117C25.2839 14.577 25.1811 14.7802 25.1789 15.0211C25.1757 15.261 25.1632 15.5323 25.1416 15.8348C25.1199 16.1374 25.0794 16.4642 25.0198 16.8154C24.9603 17.1666 24.8684 17.5637 24.7439 18.0067C24.6195 18.4497 24.468 18.882 24.2894 19.3034C24.1109 19.7248 23.9243 20.103 23.7295 20.438C23.5347 20.773 23.3562 21.0566 23.1939 21.2889C23.0316 21.5212 22.8666 21.7401 22.6988 21.9454C22.5311 22.1507 22.319 22.3819 22.0626 22.6391C21.8051 22.8952 21.6644 23.0357 21.6406 23.0605C21.6157 23.0843 21.5097 23.1729 21.3225 23.3263C21.1363 23.4808 20.9362 23.6354 20.7219 23.7899C20.5088 23.9433 20.3129 24.0714 20.1344 24.174C19.9558 24.2767 19.7405 24.3939 19.4884 24.5257C19.2373 24.6587 18.9657 24.7818 18.6736 24.8953C18.3814 25.0088 18.073 25.1141 17.7484 25.2114C17.4238 25.3086 17.11 25.3843 16.807 25.4383C16.5041 25.4923 16.1605 25.5382 15.7764 25.5761L15.2002 25.6328V25.6409H14.1452V25.6328L14.0072 25.6247C13.9152 25.6193 13.8395 25.6139 13.78 25.6085C13.7205 25.6031 13.4959 25.5733 13.1064 25.5193C12.7169 25.4653 12.4112 25.4113 12.1894 25.3572C11.9675 25.3032 11.6375 25.2006 11.1993 25.0493C10.761 24.898 10.3861 24.7451 10.0745 24.5906C9.76394 24.4371 9.56917 24.3399 9.49017 24.2988C9.41226 24.2588 9.32462 24.2091 9.22723 24.1497L9.08115 24.0606L9.07792 24.0557L9.07304 24.0525L9.06817 24.0492L9.06492 24.0444L9.04869 24.0363L9.03246 24.0281L9.02923 24.0233L9.02435 24.02L9.01948 24.0168L9.01623 24.0119L9.013 24.0071L9.00812 24.0038H9V23.9714L9.01623 23.9747L9.03246 23.9795L9.1055 23.9876C9.15419 23.993 9.28675 24.0011 9.50316 24.0119C9.71958 24.0228 9.9495 24.0228 10.193 24.0119C10.4364 24.0011 10.6853 23.9768 10.9396 23.939C11.1939 23.9012 11.4941 23.8364 11.8404 23.7445C12.1867 23.6526 12.5048 23.5435 12.7948 23.4171C13.0837 23.2896 13.2893 23.1945 13.4116 23.1318C13.5327 23.0702 13.7178 22.9557 13.9666 22.7882L14.3399 22.537L14.3432 22.5321L14.3481 22.5289L14.3529 22.5256L14.3562 22.5208L14.3594 22.5159L14.3643 22.5127L14.3692 22.5094L14.3724 22.5046L14.3886 22.4997L14.4049 22.4965L14.4081 22.4802L14.413 22.464L14.4179 22.4608L14.4211 22.4559L14.2913 22.4478C14.2047 22.4424 14.1208 22.437 14.0397 22.4316C13.9585 22.4262 13.8314 22.4019 13.6583 22.3587C13.4851 22.3155 13.2985 22.2506 13.0983 22.1642C12.8981 22.0777 12.7033 21.9751 12.514 21.8562C12.3246 21.7374 12.1877 21.6385 12.1033 21.5596C12.02 21.4818 11.9118 21.3716 11.7787 21.229C11.6467 21.0853 11.532 20.9377 11.4346 20.7865C11.3372 20.6352 11.2442 20.4607 11.1555 20.2629L11.0207 19.9679L11.0126 19.9436L11.0045 19.9193L10.9996 19.9031L10.9964 19.8869L11.0207 19.8901L11.0451 19.895L11.2236 19.9193C11.3427 19.9355 11.5293 19.9409 11.7836 19.9355C12.0379 19.9301 12.2137 19.9193 12.3111 19.9031C12.4085 19.8869 12.468 19.8761 12.4896 19.8707L12.5221 19.8626L12.5627 19.8545L12.6032 19.8464L12.6065 19.8415L12.6114 19.8383L12.6162 19.835L12.6195 19.8302L12.587 19.8221L12.5546 19.814L12.5221 19.8059L12.4896 19.7978L12.4572 19.7896C12.4355 19.7843 12.3977 19.7734 12.3436 19.7572C12.2895 19.741 12.1434 19.6816 11.9053 19.5789C11.6673 19.4763 11.4779 19.3763 11.3372 19.2791C11.1962 19.1816 11.0618 19.0749 10.9347 18.9598C10.8081 18.8431 10.6691 18.6929 10.5176 18.5092C10.3661 18.3255 10.2308 18.1121 10.1118 17.869C9.99279 17.6258 9.90352 17.3935 9.844 17.172C9.78472 16.9518 9.74561 16.7266 9.72716 16.4993L9.69793 16.159L9.71416 16.1622L9.73039 16.1671L9.74662 16.1752L9.76285 16.1833L9.77908 16.1914L9.79531 16.1995L10.0469 16.3129C10.2146 16.3886 10.4229 16.4534 10.6718 16.5074C10.9207 16.5615 11.0694 16.5912 11.1181 16.5966L11.1912 16.6047H11.3372L11.334 16.5998L11.3291 16.5966L11.3243 16.5934L11.321 16.5885L11.3178 16.5836L11.3129 16.5804L11.308 16.5771L11.3048 16.5723L11.2885 16.5642L11.2723 16.5561L11.2691 16.5512L11.2642 16.548L11.2593 16.5447L11.2561 16.5399L11.2399 16.5318L11.2236 16.5237L11.2204 16.5188C11.2171 16.5166 11.1706 16.482 11.0808 16.4151C10.9921 16.347 10.899 16.2589 10.8016 16.1509C10.7042 16.0428 10.6069 15.9293 10.5095 15.8105C10.4119 15.6914 10.325 15.5639 10.2498 15.4296C10.174 15.2945 10.094 15.1227 10.0096 14.9142C9.92625 14.7067 9.86294 14.4976 9.81966 14.2869C9.77639 14.0762 9.75204 13.8682 9.74662 13.6629C9.74121 13.4576 9.74662 13.282 9.76285 13.1361C9.77908 12.9902 9.81154 12.8254 9.86023 12.6417C9.90893 12.4581 9.97927 12.2636 10.0712 12.0582L10.2092 11.7503L10.2173 11.726L10.2254 11.7017L10.2303 11.6984L10.2335 11.6935L10.2368 11.6887L10.2417 11.6854L10.2465 11.6887L10.2498 11.6935L10.253 11.6984L10.2579 11.7017L10.2628 11.7049L10.266 11.7098L10.2693 11.7146L10.2741 11.7179L10.2822 11.7341L10.2904 11.7503L10.2952 11.7535L10.2985 11.7584L10.5176 12.0015C10.6637 12.1636 10.8368 12.3446 11.037 12.5445C11.2372 12.7444 11.3481 12.8481 11.3697 12.8557C11.3914 12.8643 11.4184 12.8892 11.4509 12.9303C11.4833 12.9702 11.5915 13.0659 11.7755 13.2171C11.9594 13.3684 12.2002 13.544 12.4977 13.7439C12.7953 13.9438 13.1253 14.141 13.4878 14.3355C13.8503 14.53 14.2399 14.7056 14.6564 14.8623C15.073 15.019 15.3652 15.1216 15.5329 15.1703C15.7006 15.2189 15.9874 15.281 16.3931 15.3567C16.7989 15.4323 17.1046 15.4809 17.3102 15.5025C17.5158 15.5241 17.6565 15.5366 17.7322 15.5398L17.8458 15.543L17.8426 15.5187L17.8377 15.4944L17.8052 15.2918C17.7836 15.1568 17.7728 14.9676 17.7728 14.7245C17.7728 14.4814 17.7917 14.2572 17.8296 14.0519C17.8675 13.8466 17.9243 13.6386 18 13.4278C18.0757 13.2171 18.1499 13.048 18.2224 12.9205C18.296 12.7941 18.3923 12.6498 18.5113 12.4878C18.6303 12.3257 18.7845 12.1582 18.9739 11.9853C19.1632 11.8124 19.3796 11.6584 19.6231 11.5234C19.8665 11.3883 20.0911 11.2856 20.2967 11.2154C20.5023 11.1452 20.6754 11.0992 20.8161 11.0776C20.9567 11.056 21.0271 11.0436 21.0271 11.0404Z"
                  fill="#909090"
                />
              </svg>
            </SocialMediaIcon>
            <SocialMediaIcon>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                viewBox="0 0 36 37"
                fill="none"
              >
                <rect
                  y="0.338867"
                  width="36"
                  height="36"
                  rx="8"
                  fill="#1E1E1E"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M9 18.3389C9 14.7437 9 12.9462 9.85669 11.6514C10.2392 11.0733 10.7344 10.5781 11.3126 10.1956C12.6073 9.33887 14.4049 9.33887 18 9.33887C21.5951 9.33887 23.3927 9.33887 24.6874 10.1956C25.2656 10.5781 25.7608 11.0733 26.1433 11.6514C27 12.9462 27 14.7437 27 18.3389C27 21.934 27 23.7316 26.1433 25.0263C25.7608 25.6045 25.2656 26.0996 24.6874 26.4822C23.3927 27.3389 21.5951 27.3389 18 27.3389C14.4049 27.3389 12.6073 27.3389 11.3126 26.4822C10.7344 26.0996 10.2392 25.6045 9.85669 25.0263C9 23.7316 9 21.934 9 18.3389ZM22.6586 18.3389C22.6586 20.9122 20.5725 22.9983 17.9992 22.9983C15.4259 22.9983 13.3398 20.9122 13.3398 18.3389C13.3398 15.7656 15.4259 13.6795 17.9992 13.6795C20.5725 13.6795 22.6586 15.7656 22.6586 18.3389ZM17.9992 21.4219C19.7019 21.4219 21.0822 20.0416 21.0822 18.3389C21.0822 16.6362 19.7019 15.2559 17.9992 15.2559C16.2965 15.2559 14.9162 16.6362 14.9162 18.3389C14.9162 20.0416 16.2965 21.4219 17.9992 21.4219ZM22.8427 14.5402C23.4473 14.5402 23.9375 14.0501 23.9375 13.4454C23.9375 12.8408 23.4473 12.3506 22.8427 12.3506C22.238 12.3506 21.7478 12.8408 21.7478 13.4454C21.7478 14.0501 22.238 14.5402 22.8427 14.5402Z"
                  fill="#909090"
                />
              </svg>
            </SocialMediaIcon>
            <SocialMediaIcon>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                viewBox="0 0 36 37"
                fill="none"
              >
                <rect
                  y="0.338867"
                  width="36"
                  height="36"
                  rx="8"
                  fill="#1E1E1E"
                />
                <path
                  d="M9 11.7589C9 11.1817 9.20271 10.7055 9.60811 10.3303C10.0135 9.95516 10.5405 9.76758 11.1892 9.76758C11.8263 9.76758 12.3417 9.95227 12.7355 10.3217C13.1409 10.7026 13.3436 11.199 13.3436 11.8109C13.3436 12.365 13.1467 12.8267 12.7529 13.1961C12.3475 13.5771 11.8147 13.7676 11.1544 13.7676H11.1371C10.5 13.7676 9.98456 13.5771 9.59073 13.1961C9.19691 12.8152 9 12.3361 9 11.7589ZM9.22587 26.9104V15.3433H13.083V26.9104H9.22587ZM15.2201 26.9104H19.0772V20.4516C19.0772 20.0475 19.1236 19.7358 19.2162 19.5165C19.3784 19.124 19.6245 18.7921 19.9546 18.5208C20.2847 18.2495 20.6988 18.1139 21.1969 18.1139C22.4942 18.1139 23.1429 18.9855 23.1429 20.7286V26.9104H27V20.2784C27 18.5699 26.5946 17.2741 25.7838 16.391C24.973 15.5078 23.9015 15.0663 22.5695 15.0663C21.0753 15.0663 19.9112 15.707 19.0772 16.9884V17.023H19.0598L19.0772 16.9884V15.3433H15.2201C15.2432 15.7127 15.2548 16.8614 15.2548 18.7892C15.2548 20.7171 15.2432 23.4241 15.2201 26.9104Z"
                  fill="#909090"
                />
              </svg>
            </SocialMediaIcon>
            <SocialMediaIcon>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                viewBox="0 0 36 37"
                fill="none"
              >
                <rect
                  y="0.338867"
                  width="36"
                  height="36"
                  rx="8"
                  fill="#1E1E1E"
                />
                <path
                  d="M18.4383 25.319L14.3761 25.2431C13.0608 25.2167 11.7423 25.2695 10.4528 24.9954C8.49128 24.5859 8.35232 22.578 8.20691 20.8937C8.00654 18.5259 8.08411 16.1151 8.46222 13.767C8.67567 12.4495 9.51571 11.6633 10.8148 11.5778C15.2001 11.2673 19.6146 11.3041 23.9903 11.4489C24.4524 11.4622 24.9177 11.5348 25.3734 11.6174C27.6227 12.0203 27.6775 14.2957 27.8233 16.2112C27.9688 18.1464 27.9074 20.0915 27.6294 22.0136C27.4065 23.605 26.9798 24.9395 25.1795 25.0684C22.9237 25.2368 20.7197 25.3725 18.4576 25.3293C18.4577 25.319 18.4447 25.319 18.4383 25.319ZM16.0501 21.2901C17.75 20.2926 19.4175 19.3119 21.1076 18.3211C19.4046 17.3237 17.7403 16.3429 16.0501 15.3522V21.2901Z"
                  fill="#909090"
                />
              </svg>
            </SocialMediaIcon>
          </SocialMediaIcons>
        </LogoArea>
        <Links>
          <LinkRow>
            <Typography
              size="2xl"
              weight="medium"
              color={Colors.grey100}
              mb="2.4"
            >
              Company
            </Typography>
            <LinkItem>
              <LinkText
                to="/blog"
                text="Blog"
                underline={false}
                color={Colors.grey500}
                size="xl"
              />
            </LinkItem>
            <LinkItem>
              <LinkText
                to="/careers"
                text="Careers"
                underline={false}
                color={Colors.grey500}
                size="xl"
              />
            </LinkItem>
          </LinkRow>{" "}
          <LinkRow>
            <Typography
              size="2xl"
              weight="medium"
              color={Colors.grey100}
              mb="2.4"
            >
              Product
            </Typography>
            <LinkItem>
              <LinkText
                to="/overview/rated-tube"
                text="Rated Tube"
                underline={false}
                color={Colors.grey500}
                size="xl"
              />
            </LinkItem>
            <LinkItem>
              <LinkText
                to="/overview/cover-song-licensing"
                text="Cover Song Licensing"
                underline={false}
                color={Colors.grey500}
                size="xl"
              />
            </LinkItem>{" "}
            <LinkItem>
              <LinkText
                to="/overview/rated-afrika-playlist"
                text="Rated Afrika Playlist"
                underline={false}
                color={Colors.grey500}
                size="xl"
              />
            </LinkItem>{" "}
            <LinkItem>
              <LinkText
                to="/overview/rated-fans"
                text="Rated Fans"
                underline={false}
                color={Colors.grey500}
                size="xl"
              />
            </LinkItem>{" "}
            <LinkItem>
              <LinkText
                to="/overview/promo-cards"
                text="Promo Cards"
                underline={false}
                color={Colors.grey500}
                size="xl"
              />
            </LinkItem>
          </LinkRow>{" "}
          <LinkRow>
            <Typography
              size="2xl"
              weight="medium"
              color={Colors.grey100}
              mb="2.4"
            >
              Legal
            </Typography>
            <LinkItem>
              <LinkText
                to="/"
                text="Terms and Conditions"
                underline={false}
                color={Colors.grey500}
                size="xl"
              />
            </LinkItem>
            <LinkItem>
              <LinkText
                to="/"
                text="Privacy  Policy"
                underline={false}
                color={Colors.grey500}
                size="xl"
              />
            </LinkItem>
            <LinkItem>
              <LinkText
                to="/"
                text="Cookies Policy"
                underline={false}
                color={Colors.grey500}
                size="xl"
              />
            </LinkItem>
          </LinkRow>{" "}
          <LinkRow>
            <Typography
              size="2xl"
              weight="medium"
              color={Colors.grey100}
              mb="2.4"
            >
              Help
            </Typography>
            <LinkItem>
              <LinkText
                to="/"
                text="Support Center"
                underline={false}
                color={Colors.grey500}
                size="xl"
              />
            </LinkItem>
          </LinkRow>
        </Links>
      </Body>
      <Typography mt="3.2" align="center" size="xl" color={Colors.grey500}>
        Copyright © Rated Afrika {new Date().getFullYear()} | All Rights
        Reserved
      </Typography>

      <BackgroundText>Rated Afrika</BackgroundText>

      <WavesContainer>
        <Waves />
      </WavesContainer>
    </Container>
  );
};

export default Footer;

const Container = styled.footer`
  width: 100%;
  padding-top: 5.5rem;
  position: relative;
`;

const Body = styled.div`
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  border-bottom: 1px solid #4e4e4e;
  padding-bottom: 5.9rem;
  position: relative;
  z-index: 1;
  @media only screen and (max-width: 769px) {
    flex-direction: column;
    align-items: center;
  }
`;

const LogoArea = styled.div`
  width: 28%;
  @media only screen and (max-width: 769px) {
    width: 80%;
    display: flex;
    align-items: center;
    flex-direction: column;
  }
`;

const SocialMediaIcons = styled.div`
  display: flex;
  align-items: center;
  gap: 1.6rem;
`;

const SocialMediaIcon = styled.div`
  cursor: pointer;
  width: 3.6rem;
  height: 3.6rem;
`;

const Links = styled.div`
  margin-left: auto;
  display: flex;
  justify-content: space-between;
  width: 60%;
  @media only screen and (max-width: 769px) {
    margin-left: unset;
    margin-top: 3.2rem;
    width: 100%;
    display: grid;
    grid-template-columns: 45% 45%;
  }
`;

const LinkRow = styled.div``;

const LinkItem = styled.div`
  margin-bottom: 1.6rem;
`;

const BackgroundText = styled.p`
  font-size: 22.6rem;
  font-weight: 700;
  font-family: "Switzer", sans-serif;
  background: -webkit-linear-gradient(
    270deg,
    rgba(255, 255, 255, 0.01) 40%,
    rgba(255, 255, 255, 0.015) 80%,
    rgba(16, 14, 16, 0.08) 100%
  );
  background-clip: text;
  -webkit-text-fill-color: transparent;
  text-align: center;
  padding: 0;
  margin: 0;
  line-height: 15rem;
  @media only screen and (max-width: 769px) {
    font-size: 8rem;
  }
`;

const StarsContainer = styled.div`
  position: absolute;
  width: 100%;
  z-index: 0;
  @media only screen and (max-width: 769px) {
    bottom: 18%;
  }
`;

const WavesContainer = styled.div`
  width: 100%;
  margin-top: -5rem;
`;

const BodyBgImg = styled.img`
  position: absolute;
  width: 100%;
  height: 53rem;
  @media only screen and (max-width: 769px) {
    bottom: 0;
  }
`;
